import { InjectedConnector as BaseInjectedConnector } from '@web3-react/injected-connector';
import { ErrorUnlockingWallet } from '../types';
const UNLOCK_WALLET_TIMEOUT = 60 * 1000; // 60 seconds
export class InjectedConnector extends BaseInjectedConnector {
    constructor(chainId) {
        super({
            supportedChainIds: [chainId]
        });
    }
    async activate() {
        // Set a timeout to reject the promise if the wallet is not unlocked
        const timeoutPromise = new Promise((_, reject) => {
            setTimeout(() => {
                reject(new ErrorUnlockingWallet());
            }, UNLOCK_WALLET_TIMEOUT);
        });
        const activatePromise = super.activate();
        return Promise.race([activatePromise, timeoutPromise]);
    }
}
//# sourceMappingURL=InjectedConnector.js.map